import { render, staticRenderFns } from "./blockTilesNewsSettings.vue?vue&type=template&id=54f8bd62&scoped=true&"
import script from "./blockTilesNewsSettings.vue?vue&type=script&lang=js&"
export * from "./blockTilesNewsSettings.vue?vue&type=script&lang=js&"
import style0 from "./blockTilesNewsSettings.vue?vue&type=style&index=0&id=54f8bd62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8bd62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VHover,VIcon,VMenu,VSheet})
